// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"adcfacb3","200":"ac8dfc28","487":"1b9bb22e","533":"620a9490","787":"b940abb9"}[chunkId] + ".chunk.js";
};